import React, {PureComponent} from 'react';
import styled from 'styled-components';
import {Link, withRouter} from 'react-router-dom';
import {Grid, AutoSizer} from 'react-virtualized';

import {getApiUrl} from '../../lib/api';
import WidgetHeader from '../WidgetHeader';
import Button from '../Button';
import Icon from '../Icon';
class PhotoGalleryWidget extends PureComponent {
  renderGridCell = ({columnIndex, key, rowIndex, style}) => {
    const {answers, question, dashboardWidgetSet, match: {params}} = this.props;
    const extension = question.type === 'SIGNATURE' ? 'png' : 'jpg';
    const index = (rowIndex * 2) + columnIndex;
    const answer = answers[index];

    if (!answer) {
      return null;
    }

    if(!dashboardWidgetSet) {
      return (
        <GridCell key={key} style={style}>
          <Link to={`/sheet/${params.templateId}/${params.sheetIds}/data/${answer.rowId}`}>
            <Image 
              src={`${getApiUrl()}/image/${answer.value}.${extension}`} 
              title={`${question.type === 'SIGNATURE' ? 'Signed' : 'Taken'} on ${new Date(answer.dates.lastModified).toLocaleString()}`}
            />
          </Link>
        </GridCell>
      )
    } else {
      return (
        <GridCell key={key} style={style}>
            <Image 
              src={`${getApiUrl()}/image/${answer.value}.${extension}`} 
              title={`${question.type === 'SIGNATURE' ? 'Signed' : 'Taken'} on ${new Date(answer.createdDate).toLocaleString()}`}
            />
        </GridCell>
      )
    }
    
  };

  renderAutoSizer = ({width, height}) => {
    const {answers} = this.props;
    const rowCount = Math.ceil(answers.length / 2);
    const columnCount = 2;
    const rowHeight = height / 2;
    const columnWidth = (width - 32) / columnCount;
    return (
        <Grid
          style={{overflowX: 'hidden', padding: '1rem', paddingTop: 0}}
          width={width}
          height={height}
          rowCount={rowCount}
          columnCount={columnCount}
          rowHeight={rowHeight}
          columnWidth={columnWidth}
          cellRenderer={this.renderGridCell}
        />
    );
  };

  render() {
    const {id, question, options, unPin} = this.props;

    let children = [];
    let filteredOptions = options;
    if(question.pinned) {
      children.push(
        <Button id={`${id}_pin`} tertiary onClick={() => unPin(question)}>
          <Icon name="go-pin" />
        </Button>
      )
      filteredOptions = options.filter(option => option.title !== "Pin");
    }
    return (
      <React.Fragment>
        <WidgetHeader 
          id={question.id} 
          title={question.text} 
          options={filteredOptions} 
          children={children}
        />
        <ScrollContent>
          <AutoSizer children={this.renderAutoSizer} />
        </ScrollContent>
      </React.Fragment>
    );
  }
}

const ScrollContent = styled.div`
  height: 38.925rem;
`;

const GridCell = styled.div`
  padding: 0.5rem;
`;

const Image = styled(({title, ...props}) => (
  <div {...props}>
    <div>{title}</div>
  </div>
))`
  height: 100%;
  border-radius: 0.25rem;
  background-image: url(${props => props.src});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  position: relative;
  overflow: hidden;

  & > div {
    display: none;
  }

  :hover > div {
    display: flex;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(transparent, rgba(0, 0, 0, 0.6));
    align-items: flex-end;
    color: #fff;
    padding: 1rem;
  }
`;

export default withRouter(PhotoGalleryWidget);
